import { Navbar, Container, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import GameLogo from "../../assets/image/Game_Logo.png";
import "./Navbar.css";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  FaCode,
  FaGamepad,
  FaDice,
  FaVrCardboard,
  FaGlobe,
  FaMobile,
  FaServer,
  FaLaptopHouse,
  FaChalkboardTeacher,
  FaBullhorn,
  FaWifi
} from "react-icons/fa";
import { PiDroneBold } from "react-icons/pi";

import NavOne from "../../assets/image/Navbar/nav-1.jfif";
import NavTwo from "../../assets/image/Navbar/nav-2.jfif";
import NavFour from "../../assets/image/Navbar/nav-4.jfif";
import NavFive from "../../assets/image/Navbar/nav-5.jfif";
import NavSix from "../../assets/image/Navbar/nav-6.jpg";
import NavSeven from "../../assets/image/Navbar/nav-7.jfif";
import NavEight from "../../assets/image/Navbar/nav-8.jfif";
import NavNine from "../../assets/image/Navbar/nav-9.jfif";
import NavTen from "../../assets/image/Navbar/nav-10.jfif";
import NavThree from "../../assets/image/Navbar/nav-3.png";

const NavBar = () => {
  const [hoveredService, setHoveredService] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const services = [
    {
      id: "drone",
      title: "Drone sector",
      subtitle: "Aerial Intelligence Solutions",
      icon: <PiDroneBold />,
      image: NavOne,
      slug: "DroneAndEducation",
    },
    {
      id: "software",
      title: "Software Development",
      subtitle: "Custom Solutions",
      icon: <FaCode />,
      image: NavOne,
      slug: "SoftwareDevelopment",
    },
    // {
    //   id: "game",
    //   title: "Game Development",
    //   subtitle: "Immersive Games",
    //   icon: <FaGamepad />,
    //   image: NavTwo,
    //   slug: "GameDevelopment",
    // },
    // {
    //   id: "arvr",
    //   title: "AR/VR Apps",
    //   subtitle: "Virtual Experiences",
    //   icon: <FaVrCardboard />,
    //   image: NavThree,
    //   slug: "ARVRApplicationDevelopment",
    // },
    {
      id: "website",
      title: "Website Development",
      subtitle: "Responsive Sites",
      icon: <FaGlobe />,
      image: NavFour,
      slug: "WebsiteDevelopment",
    },
    {
      id: "mobile",
      title: "App Development",
      subtitle: "Mobile Apps",
      icon: <FaMobile />,
      image: NavFive,
      slug: "AppDevelopment",
    },
    // {
    //   id: "casino",
    //   title: "Casino API",
    //   subtitle: "Betting Platforms",
    //   icon: <FaDice />,
    //   image: NavSix,
    //   slug: "CasinoSportsbook",
    // },
    {
      id: "iot",
      title: "IoT Embedded System",
      subtitle: "Smart Solutions",
      icon: <FaWifi />,
      image: NavSix,
      slug: "IoTSolutions",
    },

    // {
    //   id: "devops",
    //   title: "DevOps Solutions",
    //   subtitle: "CI/CD Pipelines",
    //   icon: <FaServer />,
    //   image: NavSeven,
    //   slug: "DevOpsSolutions",
    // },
    // {
    //   id: "support",
    //   title: "IT Support",
    //   subtitle: "24/7 Support",
    //   icon: <FaLaptopHouse />,
    //   image: NavEight,
    //   slug: "ITSupportSolutions",
    // },
    {
      id: "training",
      title: "Training Programs",
      subtitle: "Skill Development",
      icon: <FaChalkboardTeacher />,
      image: NavNine,
      slug: "TrainingPrograms",
    },
    // {
    //   id: "marketing",
    //   title: "Digital Marketing",
    //   subtitle: "Online Presence",
    //   icon: <FaBullhorn />,
    //   image: NavTen,
    //   slug: "DigitalMarketing",
    // },
  ];

  const ServiceItem = ({ service, position, closeNavbar }) => (
    <Link
      to={`/services/${service.slug}`}
      className="service-item rounded-3 position-relative p-3 mb-2 d-block text-dark fw-medium"
      onMouseEnter={() => !isMobile && setHoveredService(service)}
      onMouseLeave={() => !isMobile && setHoveredService(null)}
      onClick={() => {
        setHoveredService(null);
        closeNavbar();
      }}
    >
      <div className="d-flex align-items-center" style={{ height: "40px" }}>
        {!isMobile && (
          <div className="service-icon me-3 mt-2">{service.icon}</div>
        )}
        <div className="service-text d-flex flex-column justify-content-center">
          <h6 className="mb-1">{service.title}</h6>
          <p className="mb-0 small text-muted">{service.subtitle}</p>
        </div>
      </div>

      {!isMobile && hoveredService && hoveredService.id === service.id && (
        <div
          className="preview-card position-absolute bg-white shadow-lg rounded-3 p-2"
          style={{
            top: "0",
            [position === "left" ? "left" : "right"]: "100%",
            marginLeft: position === "left" ? "10px" : undefined,
            marginRight: position === "right" ? "10px" : undefined,
            width: "250px",
            zIndex: 10,
          }}
        >
          <img
            src={service.image}
            alt={service.title}
            className="w-100 rounded-2"
            style={{ height: "120px", objectFit: "cover" }}
          />
          <div className="p-2">
            <h6 className="mb-1">{service.title}</h6>
            <p className="mb-0 small text-muted">{service.subtitle}</p>
          </div>
        </div>
      )}
    </Link>
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 992);
      if (window.innerWidth > 992) {
        setShowDropdown(false); // Ensure dropdown is hidden in desktop view
        setExpanded(false); // Close navbar in desktop view
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleMouseEnter = () => {
    if (!isMobile) {
      setShowDropdown(true);
    }
  };

  const handleMouseLeave = () => {
    if (!isMobile) {
      setShowDropdown(false);
    }
  };

  const handleDropdownClick = (e) => {
    if (isMobile) {
      e.preventDefault();
      setShowDropdown(!showDropdown);
    } else {
      navigate("/services");
      setExpanded(false);
    }
  };

  const closeNavbar = () => {
    setExpanded(false);
    setShowDropdown(false);
  };

  return (
    <>
      <Navbar
        expand="lg"
        bg="white"
        className="shadow-sm py-2 fw-semibold text-dark"
        sticky="top"
        expanded={expanded}
        onToggle={(isExpanded) => setExpanded(isExpanded)}
      >
        <Container fluid>
          <Navbar.Brand
            as={Link}
            to="/"
            className="ms-lg-5 ms-md-4 ms-3"
            onClick={closeNavbar}
          >
            <img
              src={GameLogo}
              height={40}
              alt="Game Logo"
              className="d-inline-block align-top"
            />
          </Navbar.Brand>

          <Navbar.Toggle
            aria-controls="main-navbar"
            className="ms-auto me-3 border-0"
            onClick={() => setExpanded(!expanded)}
          >
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>

          <Navbar.Collapse id="main-navbar">
            <Nav
              className="mx-auto text-center"
              style={{ fontSize: "1.15rem" }}
            >
              <Nav.Link
                as={Link}
                to="/"
                className={`px-lg-3 px-2 ${location.pathname === "/"
                  ? "active fw-bold"
                  : ""
                  }`}
                onClick={closeNavbar}
              >
                Home
              </Nav.Link>

              <Nav.Item
                className={`dropdown-hover-wrapper ${showDropdown ? "show" : ""
                  }`}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              ></Nav.Item>

              <Nav.Link
                as={Link}
                to="/about"
                className={`px-lg-3 px-2 ${location.pathname === "/about"
                  ? "active fw-bold"
                  : ""
                  }`}
                onClick={closeNavbar}
              >
                About Us
              </Nav.Link>

              <Nav.Item
                className={`dropdown-hover-wrapper ${showDropdown ? "show" : ""
                  }`}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <Nav.Link
                  as={Link}
                  to={isMobile ? "#" : "/services"}
                  className={`px-lg-3 px-2 ${location.pathname.startsWith("/services")
                    ? "active fw-bold"
                    : ""
                    }`}
                  onClick={handleDropdownClick}
                >
                  <span>Services</span>
                  <i className="bi bi-caret-down-fill px-1"></i>
                </Nav.Link>

                <div
                  className={`custom-dropdown-menu ${showDropdown ? "show" : ""
                    }`}
                >
                  <div
                    className="dropdown-columns d-flex"
                    style={{
                      width: isMobile ? "100%" : "750px",
                      height: isMobile ? "auto" : "265px",
                    }}
                  >
                    <div className="dropdown-col flex-fill">
                      <div className="service-component p-1">
                        <style>{`
                        :root {
                          --primary-color: #41C1EE;
                          --secondary-color: #6c757d;
                          --shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.1);
                          --shadow-hover: 0 4px 12px rgba(0, 0, 0, 0.15);
                        }

                        .service-component {
                          max-width: 1400px;
                          margin: 0 auto;
                        }

                        .service-item {
                          cursor: pointer;
                          transition: all 0.3s ease;
                          border: 1px solid #eee;
                          background: #fff;
                          text-decoration: none;
                          position: relative;
                          z-index: 1;
                          border-radius: 10px;
                        }

                        .service-item:hover {
                          background: #f8f9fa;
                          border-color: var(--primary-color);
                          transform: scale(1.02);
                          box-shadow: var(--shadow-hover);
                          z-index: 10;
                        }

                        .service-icon {
                          width: 48px;
                          height: 48px;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          border-radius: 10px;
                          background: #f1f3f5;
                          color: var(--primary-color);
                        }

                        .service-text h6 {
                          font-size: 1rem;
                          font-weight: 600;
                          color: #333;
                        }

                        .service-text p {
                          font-size: 0.85rem;
                          color: var(--secondary-color);
                        }

                        .preview-card {
                          margin-top: 0px;
                          display: block;
                          box-shadow: var(--shadow-sm);
                          border: 1px solid #eee;
                          width: 100%;
                          border-radius: 10px;
                          overflow: hidden;
                        }

                        .preview-card img {
                          border-radius: 10px;
                          width: 100%;
                          height: auto;
                          object-fit: cover;
                        }

                        .custom-dropdown-menu {
                          z-index: 1000;
                          border-radius: 10px;
                          box-shadow: var(--shadow-sm);
                          background: #fff;
                          padding: 10px;
                          display: none;
                        }

                        .custom-dropdown-menu.show {
                          display: block;
                        }

                        @media (min-width: 992px) {
                          .service-item {
                            padding: 1rem;
                          }
                          .preview-card {
                            max-width: 400px;
                            height: 200px;
                          }
                          .preview-card img {
                            height: 100%;
                          }
                          .custom-dropdown-menu {
                            position: absolute;
                            top: 100%;
                            left: 50%;
                            transform: translateX(-50%);
                          }
                        }

                        @media (max-width: 991px) {
                          .service-component {
                            padding: 0.5rem;
                          }
                          .service-item {
                            margin: 0.5rem auto;
                            padding: 0.75rem;
                          }
                          .dropdown-columns {
                            flex-direction: column;
                          }
                          .custom-dropdown-menu {
                            position: static;
                            width: 100%;
                            transform: none;
                          }
                          .service-text h6 {
                            font-size: 0.95rem;
                          }
                          .service-text p {
                            font-size: 0.8rem;
                          }
                        }

                        @media (max-width: 576px) {
                          .service-component {
                            padding: 0.25rem;
                          }
                          .service-item {
                            margin: 0.25rem auto;
                          }
                        }
                      `}</style>

                        <div className="row">
                          <div className="col-12 col-md-6">
                            <div className="row">
                              {services.slice(0, 3).map((service) => (
                                <div key={service.id} className="col-12">
                                  <ServiceItem
                                    service={service}
                                    position="right"
                                    closeNavbar={closeNavbar}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="row">
                              {services.slice(3, 6).map((service) => (
                                <div key={service.id} className="col-12">
                                  <ServiceItem
                                    service={service}
                                    position="left"
                                    closeNavbar={closeNavbar}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Nav.Item>

              <Nav.Link
                as={Link}
                to="/technology"
                className={`px-lg-3 px-2 ${location.pathname === "/technology"
                  ? "active fw-bold"
                  : ""
                  }`}
                onClick={closeNavbar}
              >
                Technology
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/portfolio"
                className={`px-lg-3 px-2 ${location.pathname === "/portfolio"
                  ? "active fw-bold"
                  : ""
                  }`}
                onClick={closeNavbar}
              >
                Portfolio
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/trainings"
                className={`px-lg-3 px-2 ${location.pathname === "/trainings"
                  ? "active fw-bold"
                  : ""
                  }`}
                onClick={closeNavbar}
              >
                Trainings
              </Nav.Link>
            </Nav>

            <div className="d-flex justify-content-center fs-5">
              <a
                role="button"
                tabIndex="0"
                href="/contact"
                id="contact-btn"
                className={`fw-semibold ms-lg-5 ms-3 mt-3 mt-lg-0 me-lg-5 me-3 btn ${location.pathname === "/contact"
                  ? "btn-danger fw-bold"
                  : "btn-red"
                  } text-decoration-none`}
                onClick={closeNavbar}
              >
                Contact Us
              </a>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default NavBar;
